/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

export default function Tabs(theme: Theme): any {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          padding: 0,
          fontWeight: theme.typography.fontWeightMedium,
          borderTopLeftRadius: theme.shape.borderRadius,
          borderTopRightRadius: theme.shape.borderRadius,
          textTransform: "none",
          minWidth: "auto",
          width: "auto",
          "&.Mui-selected": { color: theme.palette.text.primary },
          "&:not(:last-child)": { marginRight: 0 },
        },
        labelIcon: {
          minHeight: 48,
          paddingTop: 0,
          "& > .MuiTab-wrapper > *:first-of-type": { marginBottom: 0, marginRight: theme.spacing(1) },
        },
        wrapper: { flexDirection: "row", whiteSpace: "nowrap" },
        textColorInherit: { opacity: 1, color: theme.palette.text.secondary },
      },
    },
    MuiTabPanel: { styleOverrides: { root: { padding: 0 } } },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: 48,
          borderRadius: "50%",

          "& > svg": { width: theme.spacing(4), height: theme.spacing(4) },
        },
      },
    },
  };
}
